import useSelectStore from '../../../sharedCode/stores/selectStore';
import useDndStore from '../../../sharedCode/stores/dndStore';
import useStore from '../../../sharedCode/stores/store';
import { findGroup } from '../../../sharedCode/Utils/findDataFunctions';

export const handleDragStart = (active) => {
    // console.log('handle drag start', active);
    let dragType = active?.data?.current?.type;
    let isActiveTab = active?.data?.current?.isActiveTab;
    let width = active?.data?.current?.width;
    let collapsedGroup = active?.data?.current?.collapsedGroup;
    let isActiveGroup = active?.data?.current?.isActiveGroup;
    let groupId = active?.data?.current?.groupId;
    let numberOfTabsInside = active?.data?.current?.numberOfTabsInside;
    // let groupId = active?.data?.current?.groupId;
    // useDndStore.getState().setIsDropping(true);

    if (active)
        useDndStore.getState().setActiveItem({
            ...active?.data?.current?.data,
            dragType: dragType,
            isActiveTab: isActiveTab,
            originalGroupId: groupId,
            width: width,
            collapsedGroup: collapsedGroup,
            isActiveGroup: isActiveGroup,
            numberOfTabsInside: numberOfTabsInside
        });

    if (isActiveGroup) {
        useSelectStore.setState({ selectedIds: [active.id] });
    }
    if (dragType === 'tab') {
        let selectedIds = useSelectStore.getState().selectedIds;
        if (!selectedIds.includes(active.id)) {
            selectedIds.push(active.id);
        }
        // console.log('selected IDs', selectedIds);
        if (!isActiveTab) {
            let groupsToShow = useStore.getState().groupsToShow;
            let group = findGroup(groupsToShow, active?.data?.current.groupId);
            let draggedTabs = group.tabs.filter((tab) =>
                selectedIds.includes(tab.id)
            );
            useDndStore.setState({ dragItems: draggedTabs });
        }
        useDndStore.setState({ dragIds: selectedIds });

        // if (isActiveTab) {
        //     const activeTabs =
        //         useStore.getState().allActiveTabs[groupId].activeTabs;

        // } else {
        //     let tabGroups = useStore.getState().tabGroups;
        //     let groupSelected = findGroup(tabGroups, groupId);
        //     let tabsMoved = groupToUpdate
        // }
    } else {
        useDndStore.setState({ dragIds: [active.id] });

        // useDndStore.getState().setDragItems([active?.data?.current?.data]);
    }
    //useDndStore.setState({ globalIsDragging: true });
    return;
};
